module.exports = __webpack_public_path__ + "img/sty_1.69f6408f.png";